import { Typography, Box } from '@mui/material';
import Term from '../../../assets/images/terms/terms.png';

const T = ({ children, ...rest }) => (
    <Typography sx={{ fontFamily: '"Inter", sans-serif' }} variant="body1" {...rest}>{children}</Typography>
);
const H5 = ({ children }) => (
    <Typography sx={{ fontFamily: '"DM Sans", sans-serif' }} fontWeight="bold" variant="h5">{children}</Typography>
);
const H6 = ({ children }) => (
    <Typography sx={{ fontFamily: '"DM Sans", sans-serif' }} fontWeight="bold" variant="h6">{children}</Typography>
);

export const orbitUsageRulesContext = () => [
    [
        {
            data: (
                <Box>
                    <Box style={{ textAlign: 'center' }}><img src={Term} alt="usage rules" width="250" /></Box>
                    <br /><br />
                    <H5>ORBIT STORE</H5>
                    <br />
                    <H5>USAGE RULES FOR DIGITAL GOODS</H5>
                    <br /><br />
                    <T>
                        Effective Date: September 10, 2026
                        <br />Last Updated: September 10, 2026
                        <br /><br />
                        These Usage Rules for Digital Goods (“Usage Rules”) govern the access to and use of software applications, digital tools, systems, subscriptions, add-ons, digital services, downloadable materials, and other digital products (“Digital Goods”) obtained through the Orbit Store.
                        <br /><br />
                        These Usage Rules form part of the applicable Orbit Store Terms of Sale, Tool license terms, subscription terms, and other agreements that may apply to a Digital Good.
                        <br /><br />
                        By purchasing, subscribing to, downloading, activating, accessing, or using a Digital Good from Orbit Store, you agree to comply with these Usage Rules.
                    </T>
                    <br /><br /><br />

                    <H6>1. License to Use</H6>
                    <T>
                        <br />Unless otherwise expressly stated, Digital Goods obtained through Orbit Store are licensed, not sold.
                        <br /><br />Purchasing or subscribing to a Digital Good gives you a limited right to use the Digital Good according to the license, subscription plan, number of users, company account, features, usage limits, and other conditions applicable to your purchase.
                        <br /><br />Ownership of the Digital Good, source code, intellectual property, trademarks, documentation, designs, and related materials remains with the applicable developer, publisher, POFSIS, or other rights holder.
                    </T>
                    <br /><br /><br />

                    <H6>2. Authorized Users</H6>
                    <T>
                        <br />Digital Goods may only be used by the individual, company, organization, or authorized users covered by the purchased license or subscription.
                        <br /><br />If a subscription is purchased for a specific number of users, only that number of authorized users may access the Digital Good unless additional user licenses are purchased.
                        <br /><br />The account owner is responsible for ensuring that users under its account comply with these Usage Rules.
                    </T>
                    <br /><br /><br />

                    <H6>3. Account Credentials</H6>
                    <T>
                        <br />Users must maintain the confidentiality and security of their account credentials.
                        <br /><br />Passwords, login credentials, authentication codes, access tokens, or other security information must not be shared with unauthorized persons.
                        <br /><br />Each user should use his or her own assigned account where individual user accounts are required.
                        <br /><br />The account owner may be responsible for activities conducted through accounts under its organization.
                    </T>
                    <br /><br /><br />

                    <H6>4. Permitted Use</H6>
                    <T>
                        <br />Digital Goods may be used only for their intended and lawful purposes and in accordance with the applicable product description, subscription plan, license, documentation, and agreement.
                        <br /><br />Business Tools may be used for legitimate business activities of the subscribing company or organization.
                        <br /><br />Personal Tools may be used for the user&apos;s personal purposes unless otherwise permitted by the applicable license.
                    </T>
                    <br /><br /><br />

                    <H6>5. Prohibited Use</H6>
                    <T>
                        <br />Users must not use Digital Goods in a manner that violates applicable law, infringes the rights of another person or organization, compromises system security, or interferes with the operation of Orbit Store, POFPay, POFSIS systems, developers, or other users.
                        <br /><br />Users must not copy, reproduce, distribute, resell, rent, lease, sublicense, publish, commercially exploit, or transfer Digital Goods unless expressly authorized.
                        <br /><br />Users must not attempt to obtain unauthorized access to source code, databases, servers, system administration functions, confidential information, or other protected components.
                        <br /><br />Users must not knowingly introduce malware, malicious code, unauthorized scripts, harmful files, or other mechanisms intended to damage, disrupt, manipulate, or gain unauthorized access to a system.
                    </T>
                    <br /><br /><br />

                    <H6>6. No Unauthorized Resale or Redistribution</H6>
                    <T>
                        <br />Unless the Digital Good specifically includes reseller, distributor, white-label, or sublicensing rights, users may not sell, redistribute, sublicense, or commercially make the Digital Good available to another person or organization.
                        <br /><br />A company subscription may be used internally by authorized users of that company but may not automatically be extended to affiliated companies, clients, contractors, or third parties unless permitted by the applicable subscription or enterprise agreement.
                    </T>
                    <br /><br /><br />

                    <H6>7. User and Company Limits</H6>
                    <T>
                        <br />Certain Digital Goods may have limits based on factors such as the number of users, companies, branches, transactions, projects, clients, storage capacity, API usage, reports, AI usage, or other measurable consumption.
                        <br /><br />Users must not intentionally circumvent such limits.
                        <br /><br />Additional usage may require an upgraded subscription, additional licenses, usage-based charges, or another applicable plan.
                    </T>
                    <br /><br /><br />

                    <H6>8. Modifying Digital Goods</H6>
                    <T>
                        <br />Users may not modify, adapt, translate, reverse engineer, decompile, disassemble, or attempt to derive the source code of a Digital Good except where expressly authorized by the Tool owner or permitted by applicable law.
                        <br /><br />Configuration and customization features intentionally provided within the Digital Good may be used according to the applicable documentation and subscription plan.
                    </T>
                    <br /><br /><br />

                    <H6>9. Intellectual Property</H6>
                    <T>
                        <br />All intellectual property rights relating to Digital Goods remain with their respective owners.
                        <br /><br />This may include software, source code, databases, system architecture, algorithms, processes, trademarks, logos, interfaces, designs, reports, documentation, training materials, and other proprietary content.
                        <br /><br />No intellectual property rights are transferred to the purchaser merely because a Digital Good has been purchased or subscribed to.
                    </T>
                    <br /><br /><br />

                    <H6>10. User Data and Content</H6>
                    <T>
                        <br />Users retain responsibility for information, files, records, content, and data they upload, encode, submit, or process through a Digital Good.
                        <br /><br />Users must have the necessary authority and lawful basis to upload or process such information.
                        <br /><br />Users must not knowingly upload illegal content, malicious files, infringing materials, or information they are not authorized to process.
                        <br /><br />Use of personal information must comply with applicable privacy and data protection laws and the relevant Privacy Policy.
                    </T>
                    <br /><br /><br />

                    <H6>11. Business and Client Information</H6>
                    <T>
                        <br />Users utilizing Digital Goods for business purposes are responsible for determining who within their organization should have access to confidential, financial, employee, client, project, or other business information.
                        <br /><br />Administrators should assign appropriate permissions and remove access when users no longer require it.
                        <br /><br />Orbit Store or the applicable Tool provider may provide security features, but the subscribing organization remains responsible for properly managing its authorized users and access rights.
                    </T>
                    <br /><br /><br />

                    <H6>12. Third-Party Integrations</H6>
                    <T>
                        <br />Some Digital Goods may connect with third-party platforms, payment providers, APIs, databases, cloud services, or other external systems.
                        <br /><br />Use of those services may also be subject to the third party&apos;s own terms, fees, privacy policies, limitations, and availability.
                        <br /><br />Orbit Store does not control the continuing availability or operation of independent third-party services.
                    </T>
                    <br /><br /><br />

                    <H6>13. Updates and Improvements</H6>
                    <T>
                        <br />Digital Goods may receive updates, improvements, security patches, bug fixes, new features, interface changes, or other modifications.
                        <br /><br />Users may be required to use an updated version to continue accessing certain features.
                        <br /><br />Features may evolve as the Digital Good develops, provided that changes to paid services are handled according to applicable subscription agreements and laws.
                    </T>
                    <br /><br /><br />

                    <H6>14. Beta, Pilot and Early-Access Digital Goods</H6>
                    <T>
                        <br />A Digital Good identified as Beta, Pilot, Trial, Preview, Early Access, Prototype, or Pre-Release may still be undergoing testing and development.
                        <br /><br />Such Digital Goods may contain incomplete features, limitations, errors, temporary functionality, or features that may change before commercial release.
                        <br /><br />Users participating in beta testing may also be subject to a separate Beta Testing Agreement, confidentiality requirements, Request for Comment or Request for Change process, UAT requirements, or feedback guidelines.
                        <br /><br />Beta testers are encouraged to report verified bugs, errors, recommendations, and requested enhancements through the designated feedback process.
                    </T>
                    <br /><br /><br />

                    <H6>15. Tool-Specific Rules</H6>
                    <T>
                        <br />Certain Digital Goods may have additional rules because of their particular functions.
                        <br /><br />For example, a payment Tool, accounting Tool, HR Tool, productivity Tool, project management Tool, communication Tool, AI Tool, or administrative Tool may require additional terms.
                        <br /><br />If a Tool has its own license, acceptable use policy, service agreement, or subscription conditions, those Tool-specific terms will apply together with these Usage Rules.
                    </T>
                    <br /><br /><br />

                    <H6>16. Subscription Expiration</H6>
                    <T>
                        <br />When a subscription expires or is terminated, the user&apos;s right to use the Digital Good may end or become limited.
                        <br /><br />Certain Digital Goods may provide a grace period, read-only access, data-export period, or other post-subscription access where applicable.
                        <br /><br />Users are responsible for exporting or retaining information they need before access ends, subject to the Tool&apos;s applicable data-retention policy.
                    </T>
                    <br /><br /><br />

                    <H6>17. Suspension of Access</H6>
                    <T>
                        <br />Access to a Digital Good may be temporarily suspended where reasonably necessary because of non-payment, security concerns, suspected unauthorized activity, violation of these Usage Rules, system maintenance, legal requirements, or misuse of the Digital Good.
                        <br /><br />Where appropriate, users may be provided an opportunity to correct the issue before permanent termination.
                    </T>
                    <br /><br /><br />

                    <H6>18. Termination for Misuse</H6>
                    <T>
                        <br />Serious or repeated violations of these Usage Rules may result in restriction, suspension, or termination of access to the applicable Digital Good or Orbit Store account.
                        <br /><br />Termination does not automatically create a right to a refund where access was terminated because of a material violation by the user, subject to applicable law and the applicable refund policy.
                    </T>
                    <br /><br /><br />

                    <H6>19. Security Testing and Vulnerability Discovery</H6>
                    <T>
                        <br />Users must not perform unauthorized penetration testing, vulnerability scanning, denial-of-service testing, security exploitation, or other intrusive security testing against Orbit Store, POFPay, or Digital Goods.
                        <br /><br />Potential security vulnerabilities should be responsibly reported through the designated POFSIS or Tool Developer security or support channel.
                    </T>
                    <br /><br /><br />

                    <H6>20. Fraudulent or Abusive Activity</H6>
                    <T>
                        <br />Digital Goods must not be used for fraudulent transactions, identity misuse, unauthorized payments, deception, manipulation of system records, circumvention of controls, or other unlawful activities.
                        <br /><br />Orbit Store, POFPay, and applicable Tool Developers may investigate suspicious activity and may restrict access when reasonably necessary to protect users and systems.
                    </T>
                    <br /><br /><br />

                    <H6>21. Compliance With Laws</H6>
                    <T>
                        <br />Users are responsible for using Digital Goods in compliance with applicable laws, regulations, professional standards, contractual obligations, and industry requirements relevant to their activities.
                        <br /><br />Providing a Tool through Orbit Store does not mean that the Tool Developer is responsible for determining all legal or regulatory obligations applicable to the user&apos;s specific business.
                    </T>
                    <br /><br /><br />

                    <H6>22. Professional Tools</H6>
                    <T>
                        <br />Digital Goods relating to accounting, taxation, finance, legal matters, human resources, project management, or other professional activities are intended to assist users in performing tasks.
                        <br /><br />Unless specifically stated, the Digital Good does not replace the professional judgment, review, approval, or responsibility of qualified personnel.
                        <br /><br />Users remain responsible for reviewing important outputs before relying upon them for material business or professional decisions.
                    </T>
                    <br /><br /><br />

                    <H6>23. Availability of Digital Goods</H6>
                    <T>
                        <br />Continuous or uninterrupted availability of Digital Goods cannot always be guaranteed.
                        <br /><br />Temporary interruptions may occur because of maintenance, upgrades, security measures, third-party outages, infrastructure problems, internet connectivity, emergencies, or circumstances beyond reasonable control.
                        <br /><br />Service-level commitments, where applicable, will be governed by the applicable Service-Level Agreement or enterprise agreement.
                    </T>
                    <br /><br /><br />

                    <H6>24. Reporting Violations</H6>
                    <T>
                        <br />Users may report suspected misuse, unauthorized access, infringement, fraud, security concerns, or violations involving a Digital Good through the designated Orbit Store or POFSIS support channel.
                        <br /><br />Reports should contain sufficient information to allow the concern to be evaluated.
                    </T>
                    <br /><br /><br />

                    <H6>25. Changes to These Usage Rules</H6>
                    <T>
                        <br />Orbit Store may update these Usage Rules periodically to reflect changes in Digital Goods, technology, marketplace policies, security requirements, legal requirements, or business practices.
                        <br /><br />The latest version will indicate its effective or last-updated date.
                        <br /><br />Material changes affecting existing paid subscriptions will be communicated when reasonably appropriate or required by law.
                    </T>
                    <br /><br /><br />

                    <H6>26. Relationship With Other Agreements</H6>
                    <T>
                        <br />These Usage Rules should be read together with the:
                        <br /><br />Orbit Store Terms of Sale; Privacy Policy; Refund and Cancellation Policy; applicable Tool License Agreement; Subscription Agreement; Beta Testing Agreement; Service-Level Agreement; and any applicable Enterprise or Service Agreement.
                        <br /><br />Where a separately executed agreement contains specific terms that conflict with these general Usage Rules, the separately executed agreement will generally prevail for the matters it specifically covers.
                    </T>
                    <br /><br /><br />

                    <H6>27. Contact</H6>
                    <T>
                        <br />For questions concerning permitted use, licensing, account access, subscriptions, or Digital Goods, users may contact:
                        <br /><br />Orbit Store / POFSIS Support
                        <br />Email: [Insert Support Email]
                        <br />Website: [Insert Website]
                        <br />Business Name: [Insert Registered Legal Entity]
                        <br />Business Address: [Insert Registered Address]
                    </T>
                    <br /><br />
                </Box>
            ),
        },
    ],
];
